import React from 'react'
import { Columns, Header } from 'components/elements'
import './homeDetails.sass'
const HomeDetails = () => (
  <Columns className="is-vcentered">
    <Columns.Column size={5} className="hide-mobile">
      <img
        src="https://res.cloudinary.com/twisted-road/image/upload/s--4SBYTtM5--/fl_progressive,c_scale,q_auto,h_493,q_jpegmini:1,f_auto/v1565146194/frontend_assets/homepage-images/collage-section-points-left.jpg"
        alt="Group of motorcyclists traveling alongside a highway"
        width="640px"
        height="360px"
      />
    </Columns.Column>
    <Columns.Column offset={1} size={6}>
      <Columns className="row home-page-detail-row is-vcentered is-centered is-mobile">
        <Columns.Column size={12}>
          <h2
            className="has-text-centered has-text-weight-extra-bold mb-5 header is-size-5"
          >
            Join the fastest growing motorcycle
            <br />
            sharing community on the planet.
          </h2>
        </Columns.Column>
        <Columns.Column size={6} className="home-page-detail-block">
          <i className="fas fa-star"></i>
          <div className="home-details-block-content">
            <h3 className="has-text-weight-extra-bold is-size-6">
              5 Star Reviews
            </h3>
            <p className="is-size-6">
              We’re the most trusted motorcycle renting service for a reason.
              That's why 97% of our reviewers give us 5-star ratings.
            </p>
          </div>
        </Columns.Column>
        <Columns.Column
          size={6}
          className="home-page-detail-block user-reviews"
        >
          <i className="fas fa-user"></i>
          <div className="home-details-block-content">
            <h3 className="has-text-weight-extra-bold is-size-6">
              Users and Reviews
            </h3>
            <p className="is-size-6">
              Riders and Owners can rest assured that all Twisted Road users are
              safe and experienced motorcycle riders.
            </p>
          </div>
        </Columns.Column>
        <Columns.Column
          size={6}
          className="home-page-detail-block verification"
        >
          <i className="fas fa-lock-alt"></i>
          <div className="home-details-block-content">
            <h3 className="has-text-weight-extra-bold is-size-6">
              Verification
            </h3>
            <p className="is-size-6">
              We review every rider's driving history and ensure they have a
              current and valid motorcycle endorsement.
            </p>
          </div>
        </Columns.Column>
        <Columns.Column size={6} className="home-page-detail-block">
          <i className="fas fa-shield-check"></i>
          <div className="home-details-block-content">
            <h3 className="has-text-weight-extra-bold is-size-6">Insurance</h3>
            <p className="is-size-6">
              Our insurance covers any damage that happens during motorcycle
              rentals. Plus, riders have the option to buy damage and liability
              insurance.
            </p>
          </div>
        </Columns.Column>
        <Columns.Column size={6} className="home-page-detail-block">
          <i className="fas fa-tools"></i>
          <div className="home-details-block-content">
            <h3 className="has-text-weight-extra-bold is-size-6">
              Here to help
            </h3>
            <p className="is-size-6">
              Our team is always available to make sure that your experience
              with Twisted Road is perfect.
            </p>
          </div>
        </Columns.Column>
      </Columns>
    </Columns.Column>
  </Columns>
)

export default HomeDetails
